import React from "react";
import LoginForm from "../../components/Auth/LoginForm";
import { UserType } from "../../api/authService";

export default function Login() {
  return (
    <LoginForm
      title="Admin Login"
      requiredUserType={UserType.Admin}
      homePath="/admin"
    />
  );
}
